import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const cards = [
  { title: "Tipos", desc: "Gestiona los tipos disponibles para los objetivos", path: "tipos" },
  { title: "Niveles", desc: "Administra los niveles del sistema", path: "niveles" },
  { title: "Asignaturas", desc: "Consulta y organiza las asignaturas", path: "asignaturas" },
  { title: "Objetivos", desc: "Define y edita los objetivos", path: "objetivos" },
];

const MenuPage = () => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr", // 2 columnas iguales
        gap: "20px", // separación entre filas y columnas
        alignContent: "start",  
        width: "100%",
        mt: 2,
      }}
    >
      {cards.map((card) => (
        <Box
          key={card.title}
          component={Link}
          to={card.path}
          sx={{
            border: "2px solid #336B87",
            borderRadius: "8px",
            p: 2,
            height: "150px", // altura fija
            textDecoration: "none",
            color: "#336B87",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            transition: "background-color 0.2s ease",
            "&:hover": {
              backgroundColor: "rgba(51,107,135,0.1)",
            },
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, fontFamily: "Montserrat" }}
          >
            {card.title}
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontFamily: "Montserrat" }}
          >
            {card.desc}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default MenuPage;
